import * as React from 'react';
import { Message, MessageCategory } from '../../models';
import * as copyUtil from '../../utils/copy';
import { Menu, Icon, Popup } from 'semantic-ui-react';
import { Confirmation } from './Confirmation';
import { MessageItemEditView } from './MessageItemEditView';
export interface MessageItemReadViewProps {
  message: Message;
  id: number;
  messageCategories: MessageCategory[];
  copyMessage(id: number): void;
  deleteMessageRequest(id: number): void;
  editMessageRequest(message: Message): void;
}

export interface MessageItemReadViewState {
  copied?: boolean;
  showDeleteConfirmation: boolean;
  showEditView: boolean;
}

export class MessageItemReadView extends
  React.Component<MessageItemReadViewProps, MessageItemReadViewState> {
  messageCell: HTMLTableCellElement;

  constructor(props: MessageItemReadViewProps, state: MessageItemReadViewState) {
    super(props, state);
    this.state = {
      copied: false,
      showDeleteConfirmation: false,
      showEditView: false,
    };
  }

  getMessageElementId = () => `canned-message-${this.props.message.id}`;

  copyText = () => {
    this.props.copyMessage(this.props.message.id);
    copyUtil.copyByText(this.props.message.text);
    this.setState({ copied: true });
    setTimeout(
      () => {
        this.setState({ copied: false });
      },
      500);
  }

  onEditClick = () => {
    this.setState({ showEditView: true });
  }

  onEditConfirmationClick = (message: Message) => {
    this.setState({ showEditView: false });
    this.props.editMessageRequest(message);
  }

  onEditCancelClick = () => {
    this.setState({ showEditView: false });
  }

  onDeleteClick = () => {
    this.setState({
      showDeleteConfirmation: true,
    });
  }

  onDeleteConfirmClick = () => {
    this.setState({
      showDeleteConfirmation: false,
    });
    this.props.deleteMessageRequest(this.props.message.id);
  }
  onDeleteCancelClick = () => {
    this.setState({
      showDeleteConfirmation: false,
    });

  }

  render() {
    const { message, id, messageCategories } = this.props;
    return (
      <li className="cannedMessageItem">
        <div className="wrapper">
          <div
            className={this.state.copied ? ' message messageCopied' : 'message'}
            onClick={this.copyText}
          >
            <span
              id={`message_${id}`}
              className="messageText"
            >
              <span>
                <div>
                  {message.text}
                </div>
              </span>
            </span>
            <div className="copied"><span>Copied to clipboard</span></div>
          </div>
          {!this.state.showDeleteConfirmation && !this.state.showEditView && <Popup
            trigger={<div className="btnMenu">
              < Icon name="ellipsis vertical" id={`btnMenu_${id}`} /></div>}
            on="click"
            position="bottom center"
          >
            <Menu vertical={true} compact={true}>
              <Menu.Item onClick={this.onEditClick} id={`edit_${id}`}>Edit</Menu.Item>
              <Menu.Item onClick={this.onDeleteClick} id={`delete_${id}`}>Delete</Menu.Item>
            </Menu>
          </Popup>}
          {this.state.showDeleteConfirmation && <Confirmation
            negative={true}
            message="Are you sure you want to delete this message?"
            show={this.state.showDeleteConfirmation}
            onConfirm={this.onDeleteConfirmClick}
            onCancel={this.onDeleteCancelClick}
            confirmButtonText="Delete Message"
          />}

          {
            this.state.showEditView && <MessageItemEditView
              message={message}
              cancelEditMessage={this.onEditCancelClick}
              editMessageRequest={this.onEditConfirmationClick}
              messageCategories={messageCategories}
              hasSearchQuery={false}
              id={id}
            />}
        </div>
      </li>
    );
  }
}







// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MessageItem/MessageItemReadView.tsx